import React, {useContext} from "react";
import {View, Text} from "@react-pdf/renderer";
import PropTypes from "prop-types";

import {PrintDocumentContext} from "./printDocumentContext";
import {cartItemInterface} from "../../shoppingCart/cartItemInterface";
import PrintDocumentBodyCartItem from "./printDocumentBodyCartItem";
import {IS_LIXIL_UI} from "../../../config";


const PrintDocumentBodyBundledCartItems = (props) => {
  const {styles, cartItem, fabricatorData, locale, cartItems} = props;
  // const fabricatorSettings = fabricatorData.settings;

  const bundleProducts = cartItems ? cartItems.filter(cItem => {
    return cItem.bundleParentId && (cItem.bundleParentId === cartItem.id)
  }) : [];

  const printContext = useContext(PrintDocumentContext);

  if (fabricatorData.isAmericanStandard && !IS_LIXIL_UI) {
    // the quoting tool needs to have the bundled products hidden (only for American standard) in the cart and receipt,
    // but still send items through the API to LP.
    return null;
  }

  return (
    <View style={styles.cartItemBundled} wrap={true}>
      <Text style={[styles.cartItemSimilarTitle, styles.cartItemSimilarTitleBundled]}>
        {printContext.messages["shoppingCart.bundledItems"]}
      </Text>
      <View style={styles.cartItemSimilarTitlePadding}>
        {bundleProducts.map(bundleCartItem => {
          return <PrintDocumentBodyCartItem locale={locale}
                                            key={bundleCartItem.id}
                                            fabricatorData={fabricatorData}
                                            cartItem={bundleCartItem}
                                            cartItems={cartItems}
                                            styles={styles}/>
        })}
      </View>
    </View>
  )
};

PrintDocumentBodyBundledCartItems.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface),
  fabricatorData: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  styles: PropTypes.object.isRequired,
};

export default PrintDocumentBodyBundledCartItems
